module.exports = __webpack_public_path__ + "img/epc.cfb07e9.png";